var map = {
	"./Feet/TerribleBoots/TerribleBoots.png": 7855,
	"./Hands/TerribleGloves/TerribleGloves.png": 3230,
	"./Head/BallCapBackward/BallCapBackward.png": 1229,
	"./Head/BallCapBackward/BallCapBackward.thumbnail.png": 844,
	"./Head/BallCapForward/BallCapForward.png": 3677,
	"./Head/BallCapForward/BallCapForward.thumbnail.png": 4699,
	"./Head/CheesyGlasses/CheesyGlasses.png": 6805,
	"./Head/CheesyGlasses/CheesyGlasses.thumbnail.png": 866,
	"./Head/ConeHat/ConeHat.png": 5704,
	"./Head/ConeHat/ConeHat.thumbnail.png": 6794,
	"./Head/Headphones/Headphones.png": 4570,
	"./Head/Headphones/Headphones.thumbnail.png": 874,
	"./Head/Horns/Horns.png": 7520,
	"./Head/Horns/Horns.thumbnail.png": 58,
	"./Head/LibertySpikes/LibertySpikes.png": 8850,
	"./Head/LibertySpikes/LibertySpikes.thumbnail.png": 3129,
	"./Head/MotorcycleHelmetLowPoly/MotorcycleHelmetLowPoly.png": 1636,
	"./Head/MotorcycleHelmetLowPoly/MotorcycleHelmetLowPoly.thumbnail.png": 389,
	"./Head/SantaHat/SantaHat.png": 5127,
	"./Head/SantaHat/SantaHat.thumbnail.png": 1250,
	"./Head/Sideburns/Sideburns.png": 436,
	"./Head/Sideburns/Sideburns.thumbnail.png": 9704,
	"./Head/TopHat/TopHat.png": 2345,
	"./Head/TopHat/TopHat.thumbnail.png": 7563,
	"./legs/TerriblePants/TerriblePants.png": 6070,
	"./torso/TerribleShirt/TerribleShirt.png": 3374
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4031;